import { useMemo } from 'react';
import type { ComponentType } from 'react';
import Chart from '@components/charts/Chart';
import merge from 'lodash/merge';
import PieChartProxy from '@components/charts/pieChartProxy';
import type { ComputedPortfolioHolding } from '@/components/DeprecatedPortfolio/redux/interface';

interface Props {
  totalValue: number;
  portfolioName: string;
  options?: Record<string, unknown>;
  holdings: ComputedPortfolioHolding[];
  portfolioId?: string;
  lastUpdated?: number;
}
function HoldingsDiversification(props: Props) {
  const data = useMemo(() => {
    return props.holdings.reduce(
      (prev, current) => {
        const { exclude, currentValue, currentValueFormatted, tickerSymbol } =
          current;
        if (exclude) return prev;
        const returnType = [
          ...prev,
          {
            name: `${tickerSymbol}<br/>Market Value: <b>${currentValueFormatted}</b>`,
            y: currentValue,
          },
        ];
        return returnType;
      },
      [] as { name: string; y: number | undefined }[]
    );
  }, [props.holdings]);

  const chartOptions = useMemo(() => {
    return merge({}, props.options, {
      chart: { marginLeft: 50, marginRight: 50 },
      tooltip: {
        headerFormat: `{point.key}`,
        pointFormat: '<br>Allocation: <b>{point.percentage:.1f}%</b>',
      },
      plotOptions: {
        pie: {
          dataLabels: {
            style: {
              fontFamily: '"Roboto"',
              fontWeight: 'normal',
              fontSize: '1.3rem',
              color: '#FFFFFF',
              textShadow: 'none',
              textOutline: 'none',
            },
          },
        },
      },
      series: [
        {
          type: 'pie',
          name: props.portfolioName,
          data,
        },
      ],
    });
  }, [data, props.portfolioName, props.options]);
  return (
    <Chart
      options={chartOptions}
      modifier={`${props.portfolioId}-${props.lastUpdated}`}
    />
  );
}

HoldingsDiversification.defaultProps = {
  portfolioId: '',
  lastUpdated: 0,
};
const HoldingsDiversificationChart = PieChartProxy(
  HoldingsDiversification
) as ComponentType<Props>;
export { HoldingsDiversificationChart };
